__webpack_require__.p = "/assets/turbo/0bc35b2c/quellede/_next/";